import React from 'react';
import { Div } from '../Div/index';
import { Text } from '../Text/index';
import { useTheme } from '@mui/material/styles';

/**
 * Consistent padding, margin, and border for card header text
 */
export interface CardHeaderProps {
  children: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = (
  props: CardHeaderProps
): JSX.Element => {
  const { children } = props;
  const theme = useTheme();
  return (
    <Div mb={3} pb={1} borderBottom={`solid 1px ${theme.palette.divider}`}>
      {typeof children === 'string' ? (
        <Text variant="h3">{children}</Text>
      ) : (
        children
      )}
    </Div>
  );
};
